module.exports = __webpack_public_path__ + "static/media/sort-asc.cec24264.svg";